import BN from 'bignumber.js'

function apply (Vue) {
    Vue.filter('round', function (value, scale) {
        let s = (scale !== null && scale !== undefined) ? scale : 8;

        BN.config({ DECIMAL_PLACES: s });

        return (new BN(value)).toFixed(s);
    });
}

export default {
    apply: apply,
};